module.exports = __webpack_public_path__ + "static/media/cloud.ead75652.svg";